import { FC, useCallback } from 'react';
import { Link } from 'react-router-dom';
import classes from '../../asset/css/payment-method/method.module.css';
import goAndBackClasses from '../../asset/css/go-and-back.module.css';
import { brandName, PaymentMethodViewType } from '../../types/view/payment-method-view-type';

export const Method: FC<{ paymentMethod?: PaymentMethodViewType; updatePaymentMethodFunc: () => void }> = ({
  paymentMethod,
  updatePaymentMethodFunc,
}) => {
  const clickChangeBtnHandler = useCallback(
    (e) => {
      e.preventDefault();

      updatePaymentMethodFunc();
    },
    [updatePaymentMethodFunc]
  );

  let paymentMethodHtml = <div>不明</div>;

  if (paymentMethod) {
    paymentMethodHtml = (
      <div>
        <div>
          <div>カード種別</div>
          <div>：{brandName(paymentMethod.brand)}</div>
        </div>
        <div>
          <div>カード番号</div>
          <div>：{paymentMethod.maskedNumber}</div>
        </div>
        <div>
          <div>有効期限</div>
          <div>
            ：{`00${paymentMethod.expiryMonth}`.slice(-2)}月／{paymentMethod.expiryYear}年
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={classes.mypage_subsc_payment}>
        <h2>お支払い方法の確認</h2>
        <h3>現在のお支払い方法</h3>
        {paymentMethodHtml}
      </div>
      <div className={goAndBackClasses.mypage_subsc_go_and_back_buttons}>
        <a onClick={clickChangeBtnHandler}>変更する</a>
        <Link to="/">もどる</Link>
      </div>
    </>
  );
};
